import { api } from '../api';
import { logError } from '../../utils/logger';

// Interfaces
export interface ResumoFinanceiro {
  valorTotalRecebido: number;
  valorTotalPendente: number;
  valorRecebidoMes: number;
  valorPendenteMes: number;
  consultasPorServico: { servico: string; quantidade: number; valorTotal: number }[];
  mediaPorConsulta: number;
}

export interface RelatorioMensal {
  mes: number;
  ano: number;
  recebido: number;
  pendente: number;
  total: number;
  consultasRealizadas: number;
  consultasCanceladas: number;
}

export interface ResumoPaciente {
  totalConsultas: number;
  consultasRealizadas: number;
  consultasFuturas: number;
  valorTotalPago: number;
  valorPendente: number;
  ultimaConsulta: string | null;
  proximaConsulta: string | null;
  historicoMensal: { 
    mes: string; 
    recebido: number;
    pendente: number;
    total: number;
  }[];
}

// Serviço de relatórios CORRIGIDO
export const relatoriosService = {
  /**
   * Obtém o resumo financeiro geral
   */
  async obterResumoFinanceiro(): Promise<ResumoFinanceiro> {
    try {
      const response = await api.get<ResumoFinanceiro>('/relatorios/resumo');
      return response.data;
    } catch (error) {
      logError('RelatoriosService', 'Erro ao obter resumo financeiro', error);
      // Retornar estrutura vazia em caso de erro
      return {
        valorTotalRecebido: 0,
        valorTotalPendente: 0,
        valorRecebidoMes: 0,
        valorPendenteMes: 0,
        consultasPorServico: [],
        mediaPorConsulta: 0
      };
    }
  },
  
  /**
   * Obtém o relatório mensal dos últimos 12 meses
   */
  async obterRelatorioMensal(): Promise<RelatorioMensal[]> {
    try {
      const response = await api.get<RelatorioMensal[]>('/relatorios/mensal');
      return response.data;
    } catch (error) {
      logError('RelatoriosService', 'Erro ao obter relatório mensal', error);
      return [];
    }
  },
  
  /**
   * Obtém resumo específico de um paciente
   */
  async obterResumoPaciente(pacienteId: string): Promise<ResumoPaciente> {
    try {
      const response = await api.get<ResumoPaciente>(`/relatorios/paciente/${pacienteId}`);
      return response.data;
    } catch (error) {
      logError('RelatoriosService', `Erro ao obter resumo do paciente ${pacienteId}`, error);
      // Retornar estrutura vazia em caso de erro
      return {
        totalConsultas: 0,
        consultasRealizadas: 0,
        consultasFuturas: 0,
        valorTotalPago: 0,
        valorPendente: 0,
        ultimaConsulta: null,
        proximaConsulta: null,
        historicoMensal: []
      };
    }
  },

  /**
   * NOVO: Obtém relatório de consultas com filtros
   */
  async obterRelatorioConsultas(filtros: {
    dataInicio?: string;
    dataFim?: string;
    servico?: string;
    statusConsulta?: string;
  }) {
    try {
      const params = new URLSearchParams();
      if (filtros.dataInicio) params.append('dataInicio', filtros.dataInicio);
      if (filtros.dataFim) params.append('dataFim', filtros.dataFim);
      if (filtros.servico) params.append('servico', filtros.servico);
      if (filtros.statusConsulta) params.append('statusConsulta', filtros.statusConsulta);

      const response = await api.get(`/relatorios/consultas?${params.toString()}`);
      return response.data;
    } catch (error) {
      logError('RelatoriosService', 'Erro ao obter relatório de consultas', error);
      throw error;
    }
  },

  /**
   * NOVO: Obtém relatório financeiro com filtros
   */
  async obterRelatorioFinanceiro(filtros: {
    dataInicio?: string;
    dataFim?: string;
    statusPagamento?: string;
  }) {
    try {
      const params = new URLSearchParams();
      if (filtros.dataInicio) params.append('dataInicio', filtros.dataInicio);
      if (filtros.dataFim) params.append('dataFim', filtros.dataFim);
      if (filtros.statusPagamento) params.append('statusPagamento', filtros.statusPagamento);

      const response = await api.get(`/relatorios/financeiro?${params.toString()}`);
      return response.data;
    } catch (error) {
      logError('RelatoriosService', 'Erro ao obter relatório financeiro', error);
      throw error;
    }
  }
};
